<template>
    <ModalTopSummary>
        <template #name>
            <span class="modal-top-summary__title --name">{{ user.name }}</span>
            <span class="modal-top-summary__email">
                <span class="modal-top-summary__subtitle" v-html="$t('General.email')"></span>{{ user.memberEmail }}</span>
            <span v-if="user.department">
                <span class="modal-top-summary__subtitle" v-html="$t('ReportingTable.department')"></span>{{ user.department }}
            </span>
            <span v-if="user.team">
                <span class="modal-top-summary__subtitle" v-html="$t('ReportingTable.team')"></span>{{ user.team }}
            </span>
        </template>
        <template #completed>
            {{ user.totalCompletedCourses }}
        </template>
        <template #uncompleted>
            {{ user.totalUncompletedCourses }}
        </template>
        <template #totalWatched>
            {{ totalMinutesWatched }}
        </template>
        <template #authorizations>
            <span
                class="modal-top-summary__badge"
                v-for="(auth, index) in user.authorizationTypesSummary"
                :key="index"
                v-if="user.authorizationTypesSummary.length > 0"
            >
                {{ auth.credits }} {{  auth.label }}
            </span>
        </template>
    </ModalTopSummary>
</template>

<script>
import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'
import ModalTopSummary from 'components/user/organizationreport/modals/ModalTopSummary'
export default {
    name: 'user-table-summary',
    props:{
        user: {
            type: Object
        }
    },
    components: { ModalTopSummary },
    mixins: [convertMinutesToHours],
    computed: {
        totalMinutesWatched () {
            return this.convertMinutesToHours(this.user.totalMinutesWatched)
        },
        showSeparator () {
            return this.user.department && this.user.team
        }
    }
}
</script>
